import { FieldOptions } from '../index';
import { EasyField } from '../baseClasses/easyField';

export class EasyDateTimePickerField extends EasyField {
    controlType = 'date-time-picker';

    constructor(options: FieldOptions<Date>) {
        super(options);

        options.controlType = this.controlType;
    }
}